var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLicenseMessage)?_c('div',{staticClass:"broadcastMessage",class:{ showing : _vm.isLicenseMessage, error : _vm.isLicense }},[(_vm.isLicense)?_c('div',{staticClass:"message"},[_c('span',[_vm._v(_vm._s(_vm.message))])]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }